import { useMemo } from "react";
import { twMerge } from "@stereoagency/tailwind-config";
export default function useFormFieldStyle(param) {
    var _param_state = param.state, state = _param_state === void 0 ? "default" : _param_state;
    return useMemo(function() {
        return {
            root: "isolate flex flex-col",
            input: twMerge("peer text-body-small font-heading font-medium border border-neutral-200 rounded-md py-5 px-4 transition-colors focus:outline-none focus:border-blue-500", state === "error" && "border-red-700"),
            label: twMerge("text-label-base font-medium text-label-fg-base font-heading leading-xtight mb-[-0.375rem] ml-4 order-first z-10 transition-transform peer-focus:-translate-y-full peer-focus:-translate-x-3", state === "error" && "-translate-y-full -translate-x-3"),
            error: twMerge("px-2 pt-1 text-body-small font-heading font-medium text-red-700")
        };
    }, [
        state
    ]);
}

//# sourceMappingURL=useFormFieldStyle.js.map